//https://github.com/vuejs-templates/webpack/issues/215
import Vue from 'vue';
import VueRouter from 'vue-router'
import App from "./App.vue";
import router from "./providers/router";
import store from './providers/store/';
import AuthPlugin from "./plugins/auth";
import i18n from '@/plugins/i18n';

import VueResource from 'vue-resource';
import BootstrapVue from 'bootstrap-vue';

import 'bootstrap-vue/dist/bootstrap-vue.css'

import VueSweetAlert2 from 'vue-sweetalert2';
import Selectize from 'vue2-selectize';
import VueScrollTo from 'vue-scrollto';
import VueNumeric from 'vue-numeric'
import VueContentPlaceholders from 'vue-content-placeholders';
import {library} from '@fortawesome/fontawesome-svg-core';
import VueZoomer from 'vue-zoomer';

import { Datetime } from 'vue-datetime'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'

// If you don't need the styles, do not connect
import 'sweetalert2/dist/sweetalert2.min.css';

import '@/assets/global.css';

import {
  faCheck,
  faEdit,
  faPlus,
  faQuestionCircle,
  faTimes,
  faAngleLeft,
} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import Globalize from 'globalize';

// Import controls
import NumericInput from './components/controls/NumericInput';
import DecimalInput from './components/controls/DecimalInput';
import Delete from './components/controls/Delete';
import Validation from './components/controls/Validation';
import DatePicker from './components/controls/DatePicker';

// Import directives
import Permissions from './directives/permissions';
import Debounce from './directives/debounce';

// import filters
import './filters';

import './registerServiceWorker'

//validation library
import Vuelidate from "vuelidate/src";

Globalize.load(
  require('cldr-data/main/en/ca-gregorian'),
  require('cldr-data/main/en/currencies'),
  require('cldr-data/main/en/dateFields'),
  require('cldr-data/main/en/numbers'),
  require('cldr-data/main/en/timeZoneNames'),
  require('cldr-data/main/en/units'),
  require('cldr-data/main/nl/ca-gregorian'),
  require('cldr-data/main/nl/characters'),
  require('cldr-data/main/nl/currencies'),
  require('cldr-data/main/nl/dateFields'),
  require('cldr-data/main/nl/numbers'),
  require('cldr-data/main/nl/timeZoneNames'),
  require('cldr-data/main/nl/units'),
  require('cldr-data/supplemental/currencyData'),
  require('cldr-data/supplemental/likelySubtags'),
  require('cldr-data/supplemental/metaZones'),
  require('cldr-data/supplemental/plurals'),
  require('cldr-data/supplemental/timeData'),
  require('cldr-data/supplemental/weekData'),
);

// override globalize settings
Globalize.load(
    require('../public/assets/plugins/globalize/json/nl/ca-gregorian'),
);

Globalize.loadTimeZone(require('iana-tz-data'));

// Set "en" as our default locale.
Globalize.locale('nl');

library.add(faCheck, faQuestionCircle, faTimes, faPlus, faEdit,faAngleLeft);

//Add resources
Vue.use(VueResource);
//https://www.npmjs.com/package/vue-content-placeholders
Vue.use(VueContentPlaceholders);
//https://www.npmjs.com/package/bootstrap-vue
Vue.use(BootstrapVue);
//https://www.npmjs.com/package/vue-sweetalert2
Vue.use(VueSweetAlert2);
//https://www.npmjs.com/package/vue-scrollto
Vue.use(VueScrollTo, {
     container: "body",
     duration: 500,
     easing: "ease",
     offset: 0,
     force: true,
     cancelable: true,
     onStart: false,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 });
//https://github.com/kevinongko/vue-numeric
Vue.use(VueNumeric);
//https://www.npmjs.com/package/vue-datetime
Vue.use(Datetime);
// https://www.npmjs.com/package/vue-loading-overlay
Vue.use(Loading, { color: '#1659b1', loader: 'dots', height:255, width:255 }, {});
//https://vuelidate.js.org/
Vue.use(Vuelidate);
//https://github.com/jarvisniu/vue-zoomer
Vue.use(VueZoomer);

//Add components
Vue.component('datepicker',DatePicker);
Vue.component('delete',Delete);
Vue.component('selectize',Selectize);
Vue.component('validation',Validation);
Vue.component('numeric-input',NumericInput);
Vue.component('decimal-input',DecimalInput);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('datetime', Datetime);
Vue.component('loading', Loading);

Vue.directive('permissions', Permissions);
Vue.directive('debounce', Debounce);

Vue.use(VueRouter);
Vue.use(AuthPlugin);

Vue.config.productionTip = false;

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
});
